/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timelineemptyhint2Inputs */

const en_timelineemptyhint2 = /** @type {(inputs: Timelineemptyhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start chatting on the left, or upload files in the Documents tab — dated events land here automatically.`)
};

const pt_timelineemptyhint2 = /** @type {(inputs: Timelineemptyhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa a conversar à esquerda ou carrega ficheiros no separador Documentos — os eventos com data aparecem aqui automaticamente.`)
};

/**
* | output |
* | --- |
* | "Start chatting on the left, or upload files in the Documents tab — dated events land here automatically." |
*
* @param {Timelineemptyhint2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const timelineemptyhint2 = /** @type {((inputs?: Timelineemptyhint2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timelineemptyhint2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_timelineemptyhint2(inputs)
	return pt_timelineemptyhint2(inputs)
});
export { timelineemptyhint2 as "timelineEmptyHint" }